/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_Lines_CapturedInputs */

const en_inbound_status_lines_captured = /** @type {(inputs: Inbound_Status_Lines_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To check`)
};

/**
* | output |
* | --- |
* | "To check" |
*
* @param {Inbound_Status_Lines_CapturedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_lines_captured = /** @type {((inputs?: Inbound_Status_Lines_CapturedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_Lines_CapturedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_lines_captured(inputs)
});